import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const applicationInsights = new ApplicationInsights({
    config: {
        connectionString: process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING,
        enableCorsCorrelation: true,
        correlationHeaderExcludedDomains: ["*.authorize.net"]
    }
});

const connectionString = process.env.NEXT_PUBLIC_APPINSIGHTS_CONNECTION_STRING;
const hasValidConnectionString = connectionString && !connectionString.startsWith('#{');

if (typeof window !== 'undefined' && hasValidConnectionString) {
    applicationInsights.loadAppInsights();
}

export default applicationInsights;